import {ActivatedRoute, Params, Router} from '@angular/router';

/**
 * Writes list-page controls (search text, view, filter) into the query string.
 *
 * `merge` so one control does not wipe another, `replaceUrl` so typing in a search box does not
 * push a history entry per keystroke -- Back should leave the list, not walk the search term
 * backwards one character at a time.
 */
export function updateQueryParams(router: Router, route: ActivatedRoute, params: Params): void {
  router.navigate([], {
    relativeTo: route,
    queryParams: params,
    queryParamsHandling: 'merge',
    replaceUrl: true,
  });
}

/**
 * Comparator for distinctUntilChanged over a flat params object. Replaces the hand-written
 * field-by-field comparisons the list pages each carried, which silently stop covering a field the
 * moment someone adds one.
 */
export function shallowEqual<T extends Record<string, unknown>>(a: T, b: T): boolean {
  const keys = Object.keys(a);
  return keys.length === Object.keys(b).length && keys.every(key => a[key] === b[key]);
}
